/**
 * @file main.tab.tsx
 * @description Основная таба формы плана тестирования (test-plan).
 * Сочетает описание плана с AttachmentsRichText для вложений и сворачиваемую таблицу связанных наборов тестов.
 * Отображает статус, наименование и возможность исключения для каждого набора тестов в плане.
 * Поддерживает drag-and-drop загрузку файлов через DragNDropZone.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies [react, @src/types, @components/form-controls/drag-n-drop-zone, @components/form-controls/collapsed/attachments-rich-text, @components/form-controls/collapsed/table, @utils/table-view]
 * @related-files [@forms/test-plan/test-plan.form.tsx, @components/form-controls/collapsed/table/table.component.tsx]
 */

import { tabProps } from '@src/types';
import { DragNDropZone } from '@components/form-controls/drag-n-drop-zone';
import { AttachmentsRichText } from '@components/form-controls/collapsed/attachments-rich-text';
import { Table } from '@components/form-controls/collapsed/table';
import { getDefaultCell, getBadgeCell } from '@utils/table-view';
import { IColumnConfig } from '../../../types/pages';

export const Main = ({ control, data }: tabProps) => {
    return (
        <DragNDropZone className="flex flex-col h-full gap-[1.0585vmin]" name="attachments" control={control}>
            <AttachmentsRichText
                label="Описание"
                name="description"
                control={control}
                placeholder="Добавьте описание задачи, чтобы исполнителю было понятно, что нужно сделать в рамках задачи"
            />

            <Table
                columns={columns}
                type={data?.item?.$type || ''}
                label="Наборы тестов"
                name="predecessors"
                control={control}
                hideHeader={true}
            />
        </DragNDropZone>
    );
};

const columns: IColumnConfig[] = [
    {
        id: '$item',
        header: [{ text: 'Наименование' }],
        render: (cellValue: any, item: any) => (
            <div className="flex items-center gap-[1.0585vmin]">
                {getBadgeCell(item.state)}

                {getDefaultCell(cellValue)}

                <span>{item.name}</span>
            </div>
        )
    },
    {
        id: 'exclude',
        width: 97,
        header: [{ text: 'исключение' }],
        render: (cellValue: any) => getDefaultCell(cellValue)
    }
];
